<mat-sidenav-container class="task-container">
  <mat-sidenav class="custom-sidenav" #sidenav fixedTopGap="70" fixedInViewport mode="side" opened>
    
    <div class="task-toolbar d-flex justify-content-between align-items-center">
      <mat-form-field appearance="fill" class="mx-3 w-100">
        <input
          [disabled]="disableSearch"
          matInput
          placeholder="Durchsuchen"
          [matTooltip]="!disableSearch ? 'Suche nach ID, Titel oder spezifischen Daten aus dem Payload.' : ''"
          [(ngModel)]="searchTerm"
          (input)="filterTridys()" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      <div class="mb-4 mx-3">
        <button disabled mat-icon-button [matMenuTriggerFor]="filterMenu">
          <mat-icon>tune</mat-icon>
        </button>
        <mat-menu #filterMenu="matMenu">
          <form [formGroup]="filterForm">
            <!-- Sorting Field -->
            <mat-form-field appearance="outline">
              <mat-label>Sortieren nach</mat-label>
              <mat-select formControlName="sortKey">
                <mat-option value="id">ID</mat-option>
                <mat-option value="name">Name</mat-option>
                <mat-option value="created">Erstelldatum</mat-option>
                <mat-option value="modified">Bearbeitet</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-raised-button color="primary" type="button" (click)="applyFilters()">Anwenden</button>
            <button mat-raised-button color="warn" type="button" (click)="resetFilter()">Zurücksetzen</button>
          </form>
          
          
        </mat-menu>
        
        
      </div>
    </div>
    <div class="task-list">

      @if(isLoading) {
        <div class="spinner">
          <mat-progress-spinner color="accent" mode="indeterminate"></mat-progress-spinner>
          <p class="mt-4">Laden...</p>
        </div>
      }
    
      @if(!isLoading) {

        @if (tridyList.length > 0) {
          <mat-list style="margin-bottom: 30px">
          <!--  @for (template of workTaskTemplates; track template.id) { -->
          @for (tridy of filteredTridys; track tridy.id) {
              <mat-list-item
                (click)="onSelectTridy(tridy)"
                [class.active]="isTridyActive(tridy.id)"
                matTooltipShowDelay="1500"
                matTooltip="ID: {{ tridy.id }}"
              >
            <!-- <mat-list-item (click)="selectContext(context.id)"> -->
              <div class="d-flex w-100 justify-content-between align-items-center">
                <div>
                  <span>{{ tridy.id }}</span>
                  @if (tridy.payload?.['ddl-id']) {
                    <div class="ddl-info">DDL-ID: {{ tridy.payload?.['ddl-id'] }}</div>
                  }
                  <div class="time-details"><mat-icon>schedule</mat-icon> {{ tridy.timeStamp?.toDate() | date: 'dd.MM.yyyy - HH:mm:ss' }}</div>
                </div>
                @if (isTridyActive(tridy.id)) {
                  <mat-icon style="color:var(--warmOrange)">chevron_right</mat-icon>
                }
              </div>
            </mat-list-item>
            }
          </mat-list>
        }
        @else {
          <div class="h-100 align-items-center d-flex justify-content-center">
            <p>Nichts vorhanden.</p>
          </div>
        }
      }
    </div>
      
  </mat-sidenav>
  <mat-sidenav-content>
    <app-tridy-detail></app-tridy-detail>
  </mat-sidenav-content>
</mat-sidenav-container>
